import { combineReducers } from 'redux';
import { reducer as forms } from 'redux-form';

import issueReducer from '../reducers/issueReducer'
import itemReducer from '../reducers/itemReducer'
import roomReducer from '../reducers/roomReducer'
import diningReducer from '../reducers/diningReducer'
import communityReducer from '../reducers/communityReducer'
import repairReducer from '../reducers/repairReducer'
import workOrderReducer from '../reducers/workOrderReducer'
import residentReducer from '../reducers/residentReducer'
import activityReducer from '../reducers/activityReducer'
import categoryReducer from '../reducers/categoryReducer'
import keyCloakReducer from '../reducers/keyCloakReducer'
import themeReducer from '../reducers/themeReducer'
import thumbnailIconReducer from '../reducers/thumbnailIconReducer'
import userReducer from '../reducers/userReducer'
import dashboardReducer from '../reducers/dashboardReducer'
import deviceReducer from '../reducers/deviceReducer'
import familiarReducer from '../reducers/familiarReducer'
import headerButtonsReducer from '../reducers/headerButtonsReducer'
import homeAppsReducer from '../reducers/homeAppsReducer'
import ehubVersionReducer from '../reducers/ehubVersion'
import appsReducer from '../reducers/appsReducer'
import groupsAppsReducer from '../reducers/groupsAppsReducer'

import aparmentReducer from '../reducers/aparmentReducer'
import boardReducer from '../reducers/boardReducer'
import pinsReducer from '../reducers/pinsReducer'

import currentUrlReducer from '../reducers/currentUrlReducer'
import helpTileReducer from '../reducers/helpTileReducer';
import imagesReducer from '../reducers/imagesReducer'
import diningLocationReducer from '../reducers/diningLocationReducer'
import authReducer from '../reducers/authReducer'
import diagnosticReportReducer from '../reducers/diagnosticReportReducer';



const rootReducer = combineReducers({
	authReducer,
	form: forms,
	issueReducer,
	itemReducer,
	roomReducer,
	communityReducer,
	repairReducer,
	workOrderReducer,
	residentReducer,
	activityReducer,
	categoryReducer,
	diningReducer,
	keyCloakReducer,
	themeReducer,
	thumbnailIconReducer,
	userReducer,
	dashboardReducer,
	deviceReducer,
	familiarReducer,
	headerButtonsReducer,
	homeAppsReducer,
	ehubVersionReducer,
	appsReducer,
	groupsAppsReducer,
	aparmentReducer,
	boardReducer, 
	pinsReducer,
	currentUrlReducer,
	imagesReducer,
	helpTileReducer,
	diningLocationReducer,
	diagnosticReportReducer
})

export default rootReducer;
